module.exports = __webpack_public_path__ + "static/image/history/pc/202505.ver2_0_2.png?e8d8f703";